<template>

  <!--链接体-->
  <joyLink
      v-for="(item, index) in joyList"
      :key="item"
      :item="item"
      :index="index"
      class="animate__animated animate__fadeInDown"
  ></joyLink>

  <!--  <div>-->
  <!--    <el-row :gutter="20">-->
  <!--      <el-col :span="1"></el-col>-->
  <!--      <el-col :span="11">-->
  <!--        上一页-->
  <!--      </el-col>-->
  <!--      <el-col :span="11">-->
  <!--        下一页-->
  <!--      </el-col>-->
  <!--      <el-col :span="1"></el-col>-->
  <!--    </el-row>-->
  <!--  </div>-->
</template>

<script>
//友情链接
import joyLink from "./joyLink";
//封装好的axios
import {getRequest} from '@/utils/service'
import {baseUrl} from '@/utils/request'
import {ElMessage} from "element-plus";
import {throttle} from "throttle-debounce";


export default {
  name: "joyList",
  components: {joyLink},
  data() {
    return {
      baseUrl: '',
      //子组建数组
      joyList: [],
      //页码
      page: 1,
      //是否到底
      isFinal: true
    }
  },
  props: {},
  created() {
    this.baseUrl = baseUrl();
    //加载朋友列表
    this.loadJoyList();
  },
  mounted() {
    // 性能优化：节流，每隔一段固定的时间，再去执行指定的功能
    this.loading = throttle(300, this.scroll.bind(this));
    window.addEventListener("scroll", this.loading);
  },
  destroyed() {
    // 防止组件被解绑之后，监听事件依然存在，需要解绑
    window.removeEventListener("scroll", this.loading);
  },
  methods: {
    async loadJoyList() {
      //判断页码
      let page = this.page;

      //查询后台数据
      await getRequest(this.baseUrl + '/joy/getJoy?page=' + page + '&limit=12')
          .then((res) => {
            let data = res.data.data;

            if (data.length === 0) {
              ElMessage.warning('已经到底啦....')
              this.isFinal = false;
            } else {
              //标识位
              let num = 0;
              //标识对象
              let obj = {};
              //将数组转两个的对象  神奇操作
              for (let i = 0; i < data.length; i++) {

                //单数放第一个 双数放第二个
                if (i % 2 === 0) {
                  obj.item1 = data[i];
                  num++;
                } else {
                  obj.item2 = data[i];
                  num++;
                }

                //满两个存一次 或者最后一个存一次
                if (num === 2 || i === data.length - 1) {
                  this.joyList.push(obj);
                  obj = {};
                  num = 0
                }
              }

              //页码增加
              this.page = page + 1;
            }

          })
          .catch(function (error) {
            ElMessage.error(error)
          })
    },
    //下拉方法
    scroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      //变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;

      //变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      //滚动条到底部的条件
      if (scrollTop + windowHeight + 1 >= scrollHeight) {
        //到了这个就可以进行业务逻辑加载后台数据了
        if (this.isFinal) {
          this.loadJoyList();
        }
      }
    },
  }
}
</script>

<style scoped>

</style>